import { render, staticRenderFns } from "./MusicPlaylist.vue?vue&type=template&id=148d3b7e&scoped=true"
import script from "./MusicPlaylist.vue?vue&type=script&lang=js"
export * from "./MusicPlaylist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148d3b7e",
  null
  
)

export default component.exports